import React, { useEffect, useState } from 'react'

import { useAuthStore } from '@/app/store/authStore'
import { useSystemStore } from '@/app/store/systemStore'
import { useWialonStore } from '@/app/store/wialonStore'
import useDebounce from '@/app/hooks/useDebounce'
import { getSystemDisplayName } from '@/shared/lib/getSystemDisplayName'
import { TokenCard } from '../TokenCard/TokenCard'

const INPUT_DEBOUNCE_DELAY = 700

export const WialonTokenSection: React.FC = () => {
  const tokenAccount = useAuthStore((s) => s.tokenAccount)
  const setTokenAccount = useAuthStore((s) => s.setTokenAccount)
  const selectedSystem = useSystemStore((s) => s.selectedSystem)
  const systemToken = useWialonStore((s) => s.token)
  const setSystemToken = useWialonStore((s) => s.setToken)
  const systemUrl = useWialonStore((s) => s.url)
  const setSystemUrl = useWialonStore((s) => s.setUrl)

  const [tokenInput, setTokenInput] = useState(systemToken)
  const [urlInput, setUrlInput] = useState(systemUrl)
  const debouncedToken = useDebounce(tokenInput, INPUT_DEBOUNCE_DELAY)
  const debouncedUrl = useDebounce(urlInput, INPUT_DEBOUNCE_DELAY)

  const [isTokenValid, setIsTokenValid] = useState(false)
  const [isValidatingToken, setIsValidatingToken] = useState(false)

  const validateToken = async (token: string) => {
    if (!token) {
      setIsTokenValid(false)
      setTokenAccount('')
      return
    }

    setIsValidatingToken(true)

    const isValid = token.trim().length === 72
    setIsTokenValid(isValid)

    if (!isValid) {
      setTokenAccount('')
    }

    setIsValidatingToken(false)
  }

  const handleTokenChange = (token: string) => {
    setTokenInput(token)
    setIsTokenValid(false)
  }

  useEffect(() => {
    setSystemToken(debouncedToken)
  }, [debouncedToken, setSystemToken])

  useEffect(() => {
    setSystemUrl(debouncedUrl)
  }, [debouncedUrl, setSystemUrl])

  useEffect(() => {
    if (systemToken) {
      validateToken(systemToken)
    }
  }, [systemToken])

  return (
    <TokenCard
      systemToken={tokenInput}
      onTokenChange={handleTokenChange}
      systemUrl={urlInput}
      onUrlChange={setUrlInput}
      isTokenValid={isTokenValid}
      isValidatingToken={isValidatingToken}
      tokenAccount={tokenAccount}
      systemTitle={getSystemDisplayName(selectedSystem)}
    />
  )
}
